import React from 'react';
import ReactDOM from 'react-dom';
import CameraQuiz from './Quiz';

// Warte bis DOM geladen ist
document.addEventListener('DOMContentLoaded', function() {
    const container = document.getElementById('camera-quiz-root');
    if (container) {
        ReactDOM.render(<CameraQuiz />, container);
    }
});